const images = {
    linked: require('./linked.png'),
    github: require('./github.png'),
    gitlab: require('./gitlab.png'),
    
};
    
export default images;